import { COMPANY_ADDRESS, COMPANY_NAME } from '@/shared/constants/contact';
import { cn } from '@/shared/utils/cn';

interface ManufacturerInfoProps {
  variant?: 'mobile' | 'desktop';
  className?: string;
}

export function ManufacturerInfo({ variant = 'mobile', className }: ManufacturerInfoProps) {
  if (variant === 'desktop') {
    return (
      <div className={cn('border border-[#e2e2e2] bg-white', className)}>
        <div className="flex items-start justify-between px-4 py-3 text-sm">
          <span className="text-[#5b7da3]">Manufacturer</span>
          <div className="max-w-[62%] text-right text-[#334e68]">
            <p>{COMPANY_NAME}</p>
            <p className="mt-0.5 text-xs leading-[18px] text-[#888]">{COMPANY_ADDRESS}</p>
          </div>
        </div>
        <div className="flex items-center justify-between border-t border-[#eee] px-4 py-3 text-sm">
          <span className="text-[#5b7da3]">Country of Origin</span>
          <span className="text-[#334e68]">India</span>
        </div>
      </div>
    );
  }

  return (
    <div className={cn('text-xs leading-[18px] text-black', className)}>
      <p>
        <strong className="mb-[3px] block font-semibold">Manufacturer:</strong>
        <span>
          {COMPANY_NAME}
          <br />
          {COMPANY_ADDRESS}
        </span>
      </p>
      <p className="mt-2">
        <strong className="font-semibold">Country of Origin:</strong> India
      </p>
    </div>
  );
}
